import { Uint8BufferAttribute } from 'three';

import {
  CesiumPnts,
  getFeatureElementSize,
  PntsFeatureTable,
} from '../../../../../loader/cesium/content/pnts/types';
import { BufferAttributeAdapter } from './buffer-attribute-adapter';

export const DefaultColorBufferAttribute: BufferAttributeAdapter = (
  feature: keyof PntsFeatureTable,
  pntsData: CesiumPnts,
) => {
  const buffer = pntsData.features.featureBody;
  const offset = pntsData.features.featureTable[feature].byteOffset as number;
  const pointsCount = pntsData.features.featureTable.POINTS_LENGTH;
  return new Uint8BufferAttribute(
    new Uint8Array(buffer, offset ?? 0, getFeatureElementSize(feature) * pointsCount),
    getFeatureElementSize(feature),
    true,
  );
};
